import {
  ElementPlacementRelativeMedia,
  EnableUserProfile,
  HeaderAlignment,
  OnClickAction,
  OnPostClick
} from "api/dtos/responses/AdvanceSettingResponse";
import { MediaSize } from "api/dtos/responses/TiktokAdvanceSetting";

export const AppSettingWidget = {
  Tiktok: {
    LimitVideos: 10,
    DefaultItemGetmore: 10,
    NumberPerRow: 4,
    LoadmoreBackground: "#FF0B53",
    ItemBackground: "#fafafa",
    ItemColor: "#000000",
    Title: "My TikTok Feed",
    Caption: "",
    LabelReadmore: "Load more",
    LabelView: "View more",
    ButtonColor: "#FF0B53",
    ItemGetMore: 10,
    AdvanceSetting: {
      headerElement: {
        profilePicture: true,
        postsCount: true,
        username: true,
        followersCount: true,
        followButton: true,
        followButtonBackground: "#FF0B53",
        followingCount: true,
        headerAlignment: HeaderAlignment.Center,
        followButtonRoundCorner: 4
      },
      popupSetting: {
        onPostClick: OnPostClick.OpenDetailPopup,
        enableUserProfile: EnableUserProfile.OpenProfileInNewTab
      },
      productTagSetting: {
        onClickAction: OnClickAction.RedirectToShopifyStore,
        ctaButtonText: "Buy now"
      },
      feedContentSetting: {
        roundedCorner: 8,
        postSpacing: 12,
        autoPlayVideo: false,
        roudedCornerLoadmore: 4,
        postSpacingHorizontal: 12,
        postSpacingVertical: 4,
        textSize: 0,
        elementPlacementRelativeMedia: ElementPlacementRelativeMedia.Outside,
        mediaSize: MediaSize.Vertical,
        postElement: {
          likeCount: true,
          caption: true,
          commentCount: true,
          username: true,
          viewCount: true,
          createdDate: true
        }
      }
    }
  },
  Instagram: {
    LimitVideos: 10,
    DefaultItemGetmore: 10,
    NumberPerRow: 4,
    LoadmoreBackground:
      "linear-gradient(90.43deg, #1877F2 -127.39%, #CE00F2 -41.29%, #FF5656 86.62%, #FF6C00 210.4%)",
    LabelLoadmore: "View more",
    LabelReadmore: "Load more",
    Title: "Follow us on Instagram",
    ItemBackground: "#000000",
    ItemColor: "#fafafa",
    ButtonColor: "#4E5ECA",
    ItemGetMore: 10,
    ShowProfile: true,
    AdvanceSetting: {
      headerElement: {
        profilePicture: true,
        postsCount: true,
        username: true,
        followersCount: true,
        followButton: true,
        followButtonBackground: "#4E5ECA",
        followingCount: true
      },
      popupSetting: {
        onPostClick: OnPostClick.OpenDetailPopup,
        enableUserProfile: EnableUserProfile.OpenProfileInNewTab
      },
      productTagSetting: {
        onClickAction: OnClickAction.RedirectToShopifyStore,
        ctaButtonText: "Buy now"
      },
      feedContentSetting: {
        roundedCorner: 0,
        postSpacing: 0
      }
    }
  }
};
